import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../types.d.ts" />
import React, { useState, useEffect } from 'react';
import { Grid, Flex } from '@chakra-ui/react';
import { Checkbox, CheckboxSize } from '../../components/checkbox/checkbox';
import { styles } from './groups-detail-styles';
const getCheckboxValues = (eligibleGroupMembers)=>{
    const values = {};
    eligibleGroupMembers.forEach((member)=>{
        const roleName = member.groupRoleName || '';
        if (!values[roleName]) {
            values[roleName] = {};
        }
        values[roleName][member.userUid] = member.member;
    });
    return values;
};
const sortMembersAlphabetical = (members)=>{
    // Sorting by last name then first name
    return members.sort((a, b)=>{
        const firstNameA = a.firstName?.toUpperCase();
        const firstNameB = b.firstName?.toUpperCase();
        const lastNameA = a.lastName?.toUpperCase();
        const lastNameB = b.lastName?.toUpperCase();
        if (lastNameA && lastNameB && lastNameA < lastNameB) {
            return -1;
        }
        if (lastNameA && lastNameB && lastNameA > lastNameB) {
            return 1;
        }
        if (firstNameA && firstNameB && firstNameA < firstNameB) {
            return -1;
        }
        if (firstNameA && firstNameB && firstNameA > firstNameB) {
            return 1;
        }
        return 0;
    });
};
const sortEligibleMembers = (eligibleGroupMembers)=>{
    const selectedMembers = sortMembersAlphabetical(eligibleGroupMembers.filter((member)=>member.member));
    const unselectedMembers = sortMembersAlphabetical(eligibleGroupMembers.filter((member)=>!member.member));
    // Putting all members of group before non-members in list
    return selectedMembers.concat(unselectedMembers);
};
const GroupMembers = (props)=>{
    const classes = styles();
    const { eligibleGroupMembers, addGroupMember, groupRoleId } = props;
    const initialCheckboxValues = getCheckboxValues(eligibleGroupMembers);
    const [checkboxValues, setCheckboxValues] = useState(initialCheckboxValues);
    let initialSelected = eligibleGroupMembers.filter((user)=>user.member).length;
    const [numSelected, setNumManagersSelected] = useState(initialSelected);
    useEffect(()=>{
        setNumManagersSelected(Object.values(checkboxValues[groupRoleId] || {}).filter((x)=>x).length);
    }, [
        checkboxValues,
        groupRoleId
    ]);
    useEffect(()=>{
        const checkboxValuesMap = getCheckboxValues(eligibleGroupMembers);
        setCheckboxValues(checkboxValuesMap);
    }, [
        eligibleGroupMembers
    ]);
    const handleGroupMemberSelection = (member, event, role)=>{
        const values = {
            ...checkboxValues
        };
        values[member.groupRoleName || ''][member.userUid] = event.target.checked;
        setCheckboxValues(values);
        const editedGroupMembers = [];
        editedGroupMembers.push({
            ...member,
            member: event.target.checked,
            groupRoleName: role,
            groupRoleId: null
        });
        const groupId = member.groupId;
        addGroupMember({
            groupId,
            groupMembers: editedGroupMembers
        });
    };
    return /*#__PURE__*/ _jsxs("fieldset", {
        style: classes.fieldset,
        children: [
            /*#__PURE__*/ _jsxs("legend", {
                style: classes.legend,
                children: [
                    props.groupTitle,
                    " (",
                    numSelected,
                    " selected)"
                ]
            }),
            /*#__PURE__*/ _jsx(Flex, {
                sx: classes.memberinformation,
                children: /*#__PURE__*/ _jsx(Flex, {
                    style: classes.checkBox,
                    children: /*#__PURE__*/ _jsx(Grid, {
                        rowGap: 3,
                        templateColumns: "repeat(3, 1fr)",
                        children: sortEligibleMembers(eligibleGroupMembers).filter((user)=>user.groupRoleName === groupRoleId).map((member)=>/*#__PURE__*/ _jsxs("div", {
                                style: classes.memberInfoBox,
                                children: [
                                    /*#__PURE__*/ _jsx(Checkbox, {
                                        label: member.lastName + ', ' + member.firstName,
                                        onChange: (event)=>handleGroupMemberSelection(member, event, groupRoleId),
                                        id: member.userUid?.toString(),
                                        isChecked: !!(checkboxValues[groupRoleId] || {})[member.userUid],
                                        size: CheckboxSize.LG,
                                        dataTestId: member.userUid?.toString(),
                                        _className: classes.checkboxSpacing,
                                        spacing: "5px"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: classes.usernameLabel,
                                        children: member.userName ?? 'Username Missing'
                                    })
                                ]
                            }, `${groupRoleId}-${member.userUid ?? member.userName}`))
                    })
                })
            })
        ]
    });
};
GroupMembers.displayName = 'GroupMembers';
export { GroupMembers };
